import { SourceSettings } from '../source-settings';

export interface WebSourceSettings extends SourceSettings {
  type: 'web-search';
  maxCount?: number;
}
